



































































































































































































































import { Component, Vue } from "vue-property-decorator";
import axios from "axios";
@Component({})
export default class Home extends Vue {
  private servicio2() {
    this.$router.push({ name: "Bateas" }).catch((err) => {});
  }

  private servicio3() {
    this.$router.push({ name: "Recoleccion" }).catch((err) => {});
  }

  private servicio4() {
    this.$router.push({ name: "Moviles" }).catch((err) => {});
  }

  private irLink() {
    this.$router.push({ name: "Certificados" }).catch((err) => {});
  }

  private irLinkMobile() {
    var link = "https://api.whatsapp.com/send?phone=56951339354";
    window.open(link);
  }

  private toLink(item: any, target: any) {
    if (item && item != "") {
      window.open(item, target);
    } else {
      return;
    }
  }
}
